import React, { useEffect, useState } from 'react'
import { initKeycloak } from '../authKeycloak'

interface KeycloakGateProps {
  children: React.ReactNode
}

// Local-dev-only auth gate — mirrors MSAL's AuthenticatedTemplate, but backed by Keycloak.
// initKeycloak() redirects to the local Keycloak login page itself when there's no active
// session, so the unauthenticated state here is only ever brief/transient.
const KeycloakGate: React.FC<KeycloakGateProps> = ({ children }) => {
  const [authenticated, setAuthenticated] = useState(false)

  useEffect(() => {
    let cancelled = false
    initKeycloak().then((result) => {
      if (!cancelled) setAuthenticated(result)
    })
    return () => {
      cancelled = true
    }
  }, [])

  return authenticated ? <>{children}</> : null
}

export default KeycloakGate
